import React from 'react';
import './Loader.scss';

const Loader = () => {
  const divs = Array.from({ length: 12 }).map((_, index) => <div key={index}></div>);

  return (
    <div className="loading-container">
      <div className="lds-spinner">{divs}</div>
    </div>
  );
};

export default Loader;
